import { connect } from 'react-redux';
import SettingsDialog from './settings-dialog';
import { closeSettingsDialog, changeLocalSettings, setAlertSoundState } from '../../reducers/app.reducers';
import { proceedAllVisibleOrders, resetOrderHistory } from '../../reducers/order.reducers';

const mapStateToProps = state => ({
  open: !!state.app.isSettingsDialogOpen,
  localSettings: state.app.localSettings,
});

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(closeSettingsDialog()),
  changeLocalSettings: (key, value) => dispatch(changeLocalSettings({key, value})),
  resetOrderHistory: () => dispatch(resetOrderHistory()),
  playSound: () => {
    dispatch(setAlertSoundState(false))
    dispatch(setAlertSoundState(true))
  },
  proceedAllVisibleOrders: () => dispatch(proceedAllVisibleOrders()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingsDialog);
